import { useEffect } from "react";

import type { MapPosition } from "@locators/components/shared/hooks/useFlotiqStores";
import type { SelectedFilterType } from "@locators/components/shared/utils/convertSharedFilterData";
import { convertToURLObj } from "@locators/components/shared/utils/convertSharedFilterData";

export type UseFiltersShareParams = {
  isFiltersSharingEnabled?: boolean;
  mapPosition?: MapPosition;
  selectedFilters?: SelectedFilterType;
};

export const useFiltersShare = (params: UseFiltersShareParams) => {
  const { mapPosition, selectedFilters, isFiltersSharingEnabled } = params;

  useEffect(() => {
    if (isFiltersSharingEnabled && window) {
      const url = new URL(window.location.href);
      url.search = new URLSearchParams(convertToURLObj(mapPosition, selectedFilters)).toString();

      window.history.replaceState({}, "", url);
    }
  }, [mapPosition, selectedFilters, isFiltersSharingEnabled]);
};
